import { DatePicker } from '@material-ui/pickers'
import React from 'react'
import FlexView from 'react-flexview/lib'
import './PlansAndDurationSelect.scss'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import EventIcon from '@material-ui/icons/Event'
import { isMobile } from 'react-device-detect'
import DataLayerService from '../../services/DataLayerService'
import {
  Button,
  Dialog,
  Grid,
  IconButton,
  InputAdornment,
} from '@material-ui/core'
import {
  FirebaseConfigKey,
  FirebaseService,
} from '../../services/FirebaseService'
import { DateRangePicker } from 'materialui-daterange-picker'
import { SkyInformationPopover } from '../Core/Popover/SkyPopover'

const PLANS = {
  Day: 'Daily',
  Week: 'Weekly',
  Month: 'Monthly',
  Year: 'Annual',
}

export const PlansAndDurationSelect = ({
  startingDate = new Date(),
  endDate = new Date(),
  activePlan = 'Annual',
  disabledPlans = [],
  allPlans,
  onChange,
}) => {
  const oldDate = new Date(startingDate)
  if (oldDate < new Date()) {
    startingDate = new Date()
  }
  const minDate = new Date(
    oldDate.getFullYear(),
    oldDate.getMonth(),
    oldDate.getDate() - 1
  )
  const maxDate = new Date(
    new Date().getFullYear(),
    new Date().getMonth() + 3,
    new Date().getDate()
  )
  const nextWeek = new Date(
    oldDate.getFullYear(),
    oldDate.getMonth(),
    oldDate.getDate() + 7
  )
  const nextMonth = new Date(
    oldDate.getFullYear(),
    oldDate.getMonth() + 1,
    oldDate.getDate()
  )
  const nextYear = new Date(
    oldDate.getFullYear() + 1,
    oldDate.getMonth(),
    oldDate.getDate()
  )

  const [dateOpen, setDateOpen] = React.useState(false)
  const offersContext = React.useContext(BuyingInsuranceContextStore)
  const [showUpSale, setShowUpSale] = React.useState(true)
  const unavailablePlanText =
    'This plan is currently unavailable in your location'

  const upSalePlan = () => {
    let upSalePlan =
      offersContext.offerCart.period.plan === 'Day' ? 'Week' : 'Month'
    return upSalePlan
  }
  const upSaleLink = async () => {
    DataLayerService.pushToDataLayer({
      event: 'up-sale-click',
    })
    onPlanChange(upSalePlan())
  }
  const onPlanChange = (plan) => {
    if (disabledPlans.includes(plan)) return

    switch (plan) {
      case 'Day':
        onChange(
          plan,
          new Date(startingDate),
          new Date(
            oldDate.getFullYear(),
            oldDate.getMonth(),
            oldDate.getDate() + 1
          )
        )
        break
      case 'Week':
        onChange(plan, new Date(startingDate), nextWeek)
        break
      case 'Month':
        onChange(plan, new Date(startingDate), nextMonth)
        break
      case 'Year':
        onChange(plan, new Date(startingDate), nextYear)
        break
    }
  }

  const onDateChanged = (range) => {
    onChange('Custom', range.startDate, range.endDate)
  }

  const onStartingDateChanged = (dt) => {
    dt = new Date(dt)
    switch (activePlan) {
      case 'Day':
        onChange(
          activePlan,
          dt,
          new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + 1)
        )
        break
      case 'Week':
        onChange(
          activePlan,
          dt,
          new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + 7)
        )
        break
      case 'Month':
        onChange(
          activePlan,
          dt,
          new Date(dt.getFullYear(), dt.getMonth() + 1, dt.getDate())
        )
        break
      case 'Year':
        onChange(
          activePlan,
          dt,
          new Date(dt.getFullYear() + 1, dt.getMonth(), dt.getDate())
        )
        break
    }
  }

  React.useEffect(() => {
    onPlanChange(activePlan)
  }, [])

  const toggleDateOpen = () => setDateOpen(!dateOpen)

  return (
    <>
      {/* <FlexView vAlignContent={'center'} className="space-between full-width"> */}
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center">
        <Grid item>
          <div>
            <div className="text-small-title black bold">Starting date</div>
            <div className="text-small margin-top-small gray margin-bottom-small">
              Please select plan duration
            </div>

            <FlexView>
              {allPlans.map((plan) => (
                <>
                  <div
                    onClick={() => onPlanChange(plan)}
                    className={`plan-type-box ${
                      plan == activePlan && 'selected'
                    } ${
                      disabledPlans.includes(plan) ? 'plan-type-disabled' : ''
                    } text-body blue`}
                    key={plan}>
                    {PLANS[plan]}
                    {!isMobile && (
                      <span className="plan-type-disabled-text text-small">
                        {unavailablePlanText}
                      </span>
                    )}
                  </div>
                  {isMobile && disabledPlans.includes(plan) && (
                    <span>
                      <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
                        <div className="text-small">{unavailablePlanText}</div>
                      </SkyInformationPopover>
                    </span>
                  )}
                </>
              ))}
            </FlexView>
            {offersContext.upgradePrice > 0 && showUpSale && (
              <div
                className="up-sale-box up-sale-text"
                style={{ padding: '8px 10.8px 12px 8px' }}>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/notifications-bell.png`}
                  className="notifications-img"
                />
                <label class="up-sale-text">
                  Switch to a
                  <span
                    onClick={() => {
                      upSaleLink()
                      setShowUpSale(false)
                    }}
                    class="up-sale-text-bold">
                    {' '}
                    {PLANS[upSalePlan()]} plan{' '}
                  </span>{' '}
                  for ${offersContext.upgradePrice}
                </label>
              </div>
            )}

            <div className="text-small margin-top-small gray margin-bottom-small">
              Please select starting date
              <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
                <div className="text-small">
                  Coverage will start at purchase time or if a future date is
                  selected then coverage will be from 12:01 A.M. local time at
                  address of applicant
                </div>
              </SkyInformationPopover>
            </div>
            <DatePicker
              disablePast
              inputVariant="outlined"
              value={startingDate}
              maxDate={maxDate}
              className="clickable"
              onChange={onStartingDateChanged}
              format={FirebaseService.getValue(
                FirebaseConfigKey.LONG_DATE_FORMAT
              )}
              InputProps={{
                disableUnderline: true,
                style: { height: 40, width: 155 },
                className: 'darkbluegray',
                endAdornment: (
                  <InputAdornment>
                    <IconButton className="darkbluegray">
                      <EventIcon fontSize={'small'} className="darkbluegray" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </Grid>
        <Grid item>
          {/* <FlexView className="date-plan-box" vAlignContent={'center'} hAlignContent={'center'}>
                    <IconButton onClick={toggleDateOpen}><EventIcon className="skyblue" /></IconButton>
                    <div>
                        <div className="text-small">{activePlan}</div>
                        <div>
                            <span className="text-small black">{dayjs(startingDate).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT))} - </span>
                            <span className="text-small black">{dayjs(endDate).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT))}</span>
                        </div>
                    </div>
                </FlexView> */}
        </Grid>

        {/* </FlexView> */}
      </Grid>

      <Dialog
        maxWidth={'md'}
        onClose={() => setDateOpen(false)}
        open={dateOpen}>
        <DateRangePicker
          open={true}
          minDate={minDate}
          initialDateRange={{
            startDate: startingDate,
            endDate: endDate,
          }}
          definedRanges={[
            {
              label: 'Today',
              startDate: oldDate,
              endDate: oldDate,
            },
            {
              label: 'Next Week',
              startDate: new Date(),
              endDate: nextWeek,
            },
            {
              label: 'Next Month',
              startDate: new Date(),
              endDate: nextMonth,
            },
            {
              label: 'Next Year',
              startDate: new Date(),
              endDate: nextYear,
            },
          ]}
          maxDate={maxDate}
          toggle={toggleDateOpen}
          onChange={onDateChanged}
          wrapperClassName="custom-dt-picker"
        />
        <br />
        <FlexView hAlignContent={'right'}>
          <Button onClick={toggleDateOpen} color="primary">
            ok
          </Button>
        </FlexView>
      </Dialog>
    </>
  )
}
